enum ApplicationType {
  INDIVUPAD = 'indivupad',
}

export default ApplicationType
